export default "__VITE_ASSET__161781ff__"